var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { TouchableOpacity } from 'react-native';
import { CancelButtonIcon } from '../../../../icons';
import { getTestId } from '../../../../utils';
export var Cross = _a => {
  var visible = _a.visible,
    containerStyle = _a.containerStyle,
    onPress = _a.onPress,
    crossIconProps = _a.crossIconProps,
    _a$testID = _a.testID,
    testID = _a$testID === void 0 ? 'Cross' : _a$testID,
    restProps = __rest(_a, ["visible", "containerStyle", "onPress", "crossIconProps", "testID"]);
  return _jsx(_Fragment, {
    children: visible && _jsx(TouchableOpacity, Object.assign({
      onPress: onPress,
      style: containerStyle
    }, getTestId(testID), restProps, {
      children: _jsx(CancelButtonIcon, Object.assign({
        fontSize: 16
      }, crossIconProps, getTestId(testID, 'crossIcon')))
    }))
  });
};